import { render, staticRenderFns } from "./BusinessBankAddEditModal.vue?vue&type=template&id=b80f3d7e&"
import script from "./BusinessBankAddEditModal.vue?vue&type=script&lang=js&"
export * from "./BusinessBankAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports